import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "FolderClosed.svg",
  "use": "FolderClosed.svg-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"FolderClosed.svg\"><path d=\"M19 21.5H5c-.795-.001-1.558-.317-2.12-.88S2.001 19.295 2 18.5v-13c.001-.795.317-1.558.88-2.12S4.205 2.501 5 2.5h4.559c.63-.001 1.244.197 1.754.565s.893.888 1.091 1.485l.316.949H19c.795.001 1.558.317 2.12.88s.879 1.325.88 2.12v10c-.001.795-.317 1.558-.88 2.12s-1.325.879-2.12.88z\" fill=\"#e7bb56\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol